module.exports = __webpack_public_path__ + "img/icon-20.f6a9826d.png";